import { Box } from "@mui/material";
import { Student } from "../../../providers/studentsProvider";
import { overviewCardStyle } from "../../../misc/backofficeTheme";
import { useState } from "react";
import {
  LicenseApplication,
  Practice,
  SubscriptionPackage,
  BookedTrainingsTabs,
} from "../../student/cards/TrainingsCard";
import { BookedQuote } from "../../../providers/bookedQuotesProvider";

export function TrainingsCard2({
  student,
  selectedBookedQuote,
}: {
  student: Student;
  selectedBookedQuote: BookedQuote;
}) {
  const selectedBookedQuoteTrainings = student.bookedTrainings.filter(
    (training) => selectedBookedQuote.id === training.quoteId,
  );
  const [selectedTraining, setSelectedTraining] = useState(selectedBookedQuoteTrainings[0]);

  return (
    <Box sx={{ ...overviewCardStyle, padding: "24px 30px" }}>
      {student.bookedTrainings.length > 1 && (
        <BookedTrainingsTabs
          trainings={selectedBookedQuoteTrainings}
          bf17={student.bf17}
          setSelectedTraining={setSelectedTraining}
        />
      )}
      <Practice training={selectedTraining} />
      <SubscriptionPackage student={student} />
      <LicenseApplication student={student} training={selectedTraining} />
    </Box>
  );
}
